import React from 'react';
import PropTypes from 'prop-types';

import Style from './transactionDetails.module.css';

import { Card, InfoText, Icon, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
function TransactionDetailsQuantity({ quantity = null }) {
    if (!quantity && !Number.isInteger(quantity)) {
        return null;
    }

    return <span className={Style['quantity']}>{`x${quantity}`}</span>;
}

TransactionDetailsQuantity.propTypes = {
    quantity: PropTypes.number
};

function TransactionDetailsItem({ children = null, className = '', title = '', subtitle = null, blue = false, quantity = null, lineBreak = true, icon = null }) {
    return (
        <div className={`${Style['container-item']} ${blue ? Style['container-item__blue'] : ''} ${className}`}>
            <div className={Style['container-title-item']}>
                {icon && (
                    <div style={{ marginRight: '10px' }}>
                        <Icon name={icon} />
                    </div>
                )}
                <InfoText
                    lineBreak={lineBreak}
                    className={`${blue ? Style['container-item-left__blue'] : ''} ${!lineBreak ? Style['container-item-left__ellipsis'] : ''} ${
                        quantity && !lineBreak ? Style['container-item-left__quantity'] : ''
                    }`}
                    subtitle={subtitle}
                >
                    {title}
                </InfoText>
            </div>
            {children && (
                <div className={`${Style['container-item-right']} ${blue ? Style['container-item-right__blue'] : ''} ${quantity ? Style['container-item-right__quantity'] : ''}`}>
                    <TransactionDetailsQuantity quantity={quantity} />
                    {children}
                </div>
            )}
        </div>
    );
}

TransactionDetailsItem.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    blue: PropTypes.bool,
    lineBreak: PropTypes.bool,
    quantity: PropTypes.number,
    icon: PropTypes.string
};

function TransactionDetailsItemAction({
    children = null,
    className = '',
    title = '',
    subtitle = null,
    blue = false,
    quantity = null,
    lineBreak = true,
    number = null,
    icone = 'tickets'
}) {
    const toast = React.useContext(ToastContext);
    const [openModal, setOpenModal] = React.useState(false);
    const { t } = useTranslation();

    return (
        <div className={`${Style['container-item-action']} ${className}`}>
            <Modal size="small" open={openModal} onClose={() => setOpenModal(false)} title={t('attendee.barcode')}>
                <QRCode size={200} value={number} />
            </Modal>
            <div className={`${Style['top-item']} ${blue ? Style['container-item__blue'] : ''}`}>
                <div className={Style['container-title-item']}>
                    <div style={{ marginRight: '10px' }}>
                        <Icon name={icone} />
                    </div>

                    <InfoText
                        lineBreak={lineBreak}
                        className={`${blue ? Style['container-item-left__blue'] : ''} ${!lineBreak ? Style['container-item-left__ellipsis'] : ''} ${
                            quantity && !lineBreak ? Style['container-item-left__quantity'] : ''
                        }`}
                        subtitle={subtitle}
                    >
                        {title}
                    </InfoText>
                </div>

                {children && (
                    <div
                        className={`${Style['container-item-right']} ${blue ? Style['container-item-right__blue'] : ''} ${quantity ? Style['container-item-right__quantity'] : ''}`}
                    >
                        <TransactionDetailsQuantity quantity={quantity} />
                        {children}
                    </div>
                )}
            </div>
            {number && (
                <div className={`${Style['bottom-item']}`}>
                    <Icon name="qr" onClick={() => setOpenModal(true)} />
                    <div className={`${Style['content-number']}`}>{number}</div>
                    <Icon
                        name="copy"
                        onClick={() => {
                            navigator.clipboard.writeText(number);
                            toast.success('copyed');
                        }}
                    />
                </div>
            )}
        </div>
    );
}

TransactionDetailsItemAction.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    blue: PropTypes.bool,
    lineBreak: PropTypes.bool,
    quantity: PropTypes.number
};

export default function TransactionDetails({ children = null, className = '', title = null, ...rest }) {
    return (
        <Card className={`${Style['container']} ${className}`} {...rest}>
            {title && <div className={Style['container__title']}>{title}</div>}
            {children}
        </Card>
    );
}

TransactionDetails.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.node
};

TransactionDetails.Item = TransactionDetailsItem;
TransactionDetails.ItemAction = TransactionDetailsItemAction;
